export const USER = {
  USER_CREDINTIALS: {
    USER: { EMAIL: "demo@e-zest.in" },
    ADMIN: { EMAIL: "admin@e-zest.in" },
  },
  USER_ID: {
    USER: "channel_4",
    ADMIN: "channel_4",
  },
  USER_ROLE: {
    USER: "VIEWER",
    ADMIN: "ADMIN",
    RAPUTER: "RAPPORTEUR",
    SUPER_ADMIN: "SUPER_ADMIN",
  },
  LS_USER_ROLE_KEY: "userRole",
};